export const mockCampaigns = [
  {
    id: "1",
    name: "Product Launch Campaign",
    description: "Comprehensive social media campaign for our new product launch",
    startDate: "2024-01-15",
    endDate: "2024-01-30",
    totalEvents: 24,
    completedEvents: 18,
    pendingEvents: 4,
    errorEvents: 2,
    profiles: ["@brandaccount", "@ceohandle"],
    status: "active",
    socialNetwork: "TWITTER",
    tags: ["Product Launch", "Marketing", "Social Media", "Branding"],
  },
  {
    id: "2",
    name: "Holiday Season Promotion",
    description: "Seasonal marketing campaign for holiday sales",
    startDate: "2024-12-01",
    endDate: "2024-12-31",
    totalEvents: 45,
    completedEvents: 45,
    pendingEvents: 0,
    errorEvents: 0,
    profiles: ["@brandaccount", "@supportteam"],
    status: "completed",
    socialNetwork: "FACEBOOK",
    tags: ["Holiday", "Sales", "Seasonal"],
  },
  {
    id: "3",
    name: "Brand Awareness Q1",
    description: "First quarter brand awareness and engagement campaign",
    startDate: "2024-01-01",
    endDate: "2024-03-31",
    totalEvents: 12,
    completedEvents: 0,
    pendingEvents: 12,
    errorEvents: 0,
    profiles: ["@brandaccount"],
    status: "draft",
    socialNetwork: "TWITTER",
    tags: ["Brand Awareness", "Q1"],
  },
];